function fireAndForget(promise, label = 'anonymous') {
  promise.catch((err) => {
    DEBUG && console.warn(`[${label}] async error:`, err);
  });
}

function time() {
  var date = new Date();
  return parseInt(date.getTime().toString().slice(0, 10));
}

function unixtime() {
  var date = new Date();
  return parseInt(date.getTime().toString().slice(0, 10));
}

function gmtoffset() {
  // courtesy http://www.24hourapps.com/2009/03/javascript-gmtutc-timezone-offset.html
  var today = new Date();
  var offset = -(today.getTimezoneOffset() / 60);
  return offset;
}

function uuid7() {
  // inspired by https://github.com/nalgeon/uuidv7/blob/main/src/uuidv7.js
  const v7values = () => {
    // random bytes
    const value = new Uint8Array(16);
    crypto.getRandomValues(value);

    // current timestamp in ms
    const timestamp = BigInt(Date.now());

    // timestamp
    value[0] = Number((timestamp >> 40n) & 0xffn);
    value[1] = Number((timestamp >> 32n) & 0xffn);
    value[2] = Number((timestamp >> 24n) & 0xffn);
    value[3] = Number((timestamp >> 16n) & 0xffn);
    value[4] = Number((timestamp >> 8n) & 0xffn);
    value[5] = Number(timestamp & 0xffn);

    // version and variant
    value[6] = (value[6] & 0x0f) | 0x70;
    value[8] = (value[8] & 0x3f) | 0x80;

    return value;
  };

  const uuid = Array.from(v7values())
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return (
    uuid.slice(0, 8) +
    '-' +
    uuid.slice(8, 12) +
    '-' +
    uuid.slice(12, 16) +
    '-' +
    uuid.slice(16, 20) +
    '-' +
    uuid.slice(20)
  );
}

function urlbuilder(baseurl, params, hash) {
  baseurl = baseurl || '';
  params = params || {};
  hash = hash || '';
  var querystring = '';
  for (var i in params) {
    querystring += i + '=' + encodeURIComponent(params[i]) + '&';
  }
  var url = baseurl;
  if (querystring) {
    url += '?' + querystring.slice(0, querystring.length - 1);
  }
  if (hash) {
    url += hash;
  }
  return url;
}

// CREDIT: http://javascript.crockford.com/prototypal.html
if (typeof Object.create !== 'function') {
  Object.create = function (o) {
    function F() {}
    F.prototype = o;
    return new F();
  };
}

// CREDIT http://stackoverflow.com/questions/122102/what-is-the-most-efficent-way-to-clone-a-javascript-object/1891377#1891377
function cloneObject(obj) {
  var clone = {};
  for (var i in obj) {
    if (typeof obj[i] == 'object') clone[i] = cloneObject(obj[i]);
    else clone[i] = obj[i];
  }
  return clone;
}

// we only want props that have changed `since`
function slimObject(incoming, since) {
  const o = JSON.parse(JSON.stringify(incoming));
  return o;

  if (Boolean(o.__isNew__)) {
    return o;
  }
  // else
  Object.keys(o).forEach((key) => {
    if (key[1] === '_') {
      delete o[key];
    } else if (key !== '_key' && key[0] === '_' && key[1] !== '_') {
      if (parseInt(o[key], 10) < since) {
        delete o[key];
        delete o[key.substring(1)];
      }
    }
  });
  return o;
}

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^\s+|\s+$/g, '');
  };
}

// CREDIT: http://stackoverflow.com/questions/3629183/why-doesnt-indexof-work-on-an-array-ie8
// ... originally from https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf#Compatibility
if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (elt /*, from*/) {
    var len = this.length >>> 0;
    var from = Number(arguments[1]) || 0;
    from = from < 0 ? Math.ceil(from) : Math.floor(from);
    if (from < 0) from += len;

    for (; from < len; from++) {
      if (from in this && this[from] === elt) return from;
    }
    return -1;
  };
}

Array.prototype.unique = function () {
  var length = this.length;
  var a = [];
  var i, j; // iter
  for (i = 0; i < length; i++) {
    for (j = i + 1; j < length; j++) {
      if (this[i] === this[j]) j = ++i;
    }
    a.push(this[i]);
  }
  return a;
};

String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, 'g'), replacement);
};

var unique = function (arr) {
  var length = arr.length;
  var a = [];
  var i, j; // iter
  for (i = 0; i < length; i++) {
    for (j = i + 1; j < length; j++) {
      if (arr[i] === arr[j]) j = ++i;
    }
    a.push(arr[i]);
  }
  return a;
};

var isort = function (x, y) {
  var a = String(x).toUpperCase();
  var b = String(y).toUpperCase();
  if (a > b) return 1;
  if (a < b) return -1;
  return 0;
};

function padleft(s, l, c) {
  if (s != undefined) {
    return new Array(l - s.length + 1).join(c || '0') + s;
  } else {
    return s;
  }
}

function nescape(s) {
  s = s.replace(/"/g, '&quot;');
  s = s.replace(/</g, '&lt;');
  s = s.replace(/>/g, '&gt;');
  return s;
}

function htmlentities(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function nl2br(s) {
  return s.replace(/\n/g, '<br />');
}

function br2nl(thestring) {
  return thestring.replace(/<br>/gi, '\n');
}

function subtaskr(s) {
  var lines = s.trim().split('\n');
  for (var l = 0; l < lines.length; l++) {
    lines[l] = lines[l].trim();
    if (lines[l].slice(0, 2) == '- ') {
      lines[l] = lines[l].replace(
        '- ',
        '<span class="nosave subtask"><span>-</span></span> '
      );
    }
    if (lines[l].slice(0, 2) == 'x ') {
      lines[l] = lines[l].replace(
        'x ',
        '<span class="nosave subtask checked"><span>x</span></span> '
      );
    }
  }
  return lines.join('\n');
}

function smartparse(s) {
  var now = time();

  var task = {};
  var seq = 0;
  var name = '';
  var tags = '';
  var energy = 0;
  var etime = 0;
  var waitingfor = '';
  var startdate = '';
  var duedate = '';

  var reserved = [
    '#inbox',
    '#next',
    '#later',
    '#waiting',
    '#scheduled',
    '#someday',
    '#project',
    '#focus',
    '#due',
    '#start',
    '#e1',
    '#e2',
    '#e3',
    '#1h',
    '#2h',
    '#3h',
    '#4h',
    '#5h',
    '#6h',
    '#7h',
    '#8h',
    '#5m',
    '#10m',
    '#15m',
    '#20m',
    '#25m',
    '#30m',
    '#35m',
    '#40m',
    '#45m',
    '#50m',
    '#55m',
    '#60m',
    '#90m',
  ];

  // initial parse
  var a = s.split(' ');
  var t = []; // #tag
  for (var i = 0; i < a.length; i++) {
    if (a[i].substr(0, 1) == '#') {
      t.push(a.splice(i, 1));
      i--;
    }
  }

  // process discreet #tags
  for (var i = 0; i < t.length; i++) {
    if (false) {
    } else if (t[i] == '#e1') {
      energy = 1;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#e2') {
      energy = 2;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#e3') {
      energy = 3;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#1h') {
      etime = 60;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#2h') {
      etime = 120;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#3h') {
      etime = 180;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#4h') {
      etime = 240;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#5h') {
      etime = 360;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#6h') {
      etime = 360;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#7h') {
      etime = 480;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#8h') {
      etime = 480;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#5m') {
      etime = 5;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#10m') {
      etime = 10;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#15m') {
      etime = 15;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#20m') {
      etime = 20;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#25m') {
      etime = 30;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#30m') {
      etime = 30;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#35m') {
      etime = 45;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#40m') {
      etime = 45;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#45m') {
      etime = 45;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#55m') {
      etime = 60;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#50m') {
      etime = 60;
      t.splice(i, 1);
      i--;
    } // round up
    else if (t[i] == '#60m') {
      etime = 60;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#focus' || t[i] == '#star') {
      task.seqt = time();
      task._seqt = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#inbox') {
      task.state = NIRV.CONST.INBOX;
      task._state = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#next') {
      task.state = NIRV.CONST.NEXT;
      task._state = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#later' || t[i] == '#inactive') {
      task.state = NIRV.CONST.LATER;
      task._state = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#waiting' || t[i] == '#waitingfor') {
      task.state = NIRV.CONST.WAITING;
      task._state = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#someday') {
      task.state = NIRV.CONST.SOMEDAY;
      task._state = now;
      t.splice(i, 1);
      i--;
    } else if (t[i] == '#project') {
      task.type = NIRV.CONST.PROJECT;
      task._type = now;
      task.state = NIRV.CONST.ACTIVEPROJECT;
      task._state = now;
      t.splice(i, 1);
      i--;
    }
  }

  // process duedate
  var dparts = s.split('#due ');
  if (dparts.length > 1) {
    var dparts1 = dparts[1].split('#');
    var dstring = dparts1[0];
    var ddate = Date.parse(dstring);
    if (ddate) duedate = ddate.toString('yyyyMMdd');
  }

  // process startdate
  var sparts = s.split('#start ');
  if (sparts.length > 1) {
    var sparts1 = sparts[1].split('#');
    var sstring = sparts1[0];
    var sdate = Date.parse(sstring);
    if (sdate) {
      startdate = sdate.toString('yyyyMMdd');
      state = NIRV.CONST.SCHEDULED;
    }
  }

  // process waitingfor
  var wparts = s.split('#waiting ');
  if (wparts.length > 1) {
    var wparts1 = wparts[1].split('#');
    var wstring = wparts1[0].trim();
    if (wstring.length > 0) {
      waitingfor = wstring;
      state = NIRV.CONST.WAITING;
    }
  }

  // rebuild task name
  var fu = []; // kungfu
  fu = s.split('#due ');
  fu = fu[0];
  fu = fu.split('#start ');
  fu = fu[0];
  fu = fu.split('#waiting ');
  fu = fu[0];
  fu = fu.split(' ');
  for (var i = 0; i < fu.length; i++) {
    if (fu[i].substr(0, 1) == '#') {
      fu.splice(i, 1);
      i--;
    }
  }
  name = fu.join(' ');

  // rebuild task tags
  var tags = [];
  for (var i = 0; i < t.length; i++) {
    if (reserved.indexOf(t[i].toString()) == -1) {
      tags.push(t[i].toString().substr(1));
    }
  }
  tags.unique();
  tags.sort();

  task.name = name;
  task._name = now;
  task.tags = tags.join(',');
  task._tags = now;
  task.seq = now;
  task._seq = now;
  if (startdate != null) {
    task.startdate = startdate;
    task._startdate = now;
  }
  if (duedate != null) {
    task.duedate = duedate;
    task._duedate = now;
  }
  if (task.type != undefined && task.type == NIRV.CONST.TASK) {
    task.energy = energy;
    task._energy = now;
    task.etime = etime;
    task._etime = now;
    if (waitingfor != null) {
      task.waitingfor = waitingfor.trim();
      task._waitingfor = now;
    }
  }

  return task;
}

function smartentry(task) {
  // Regex Credit: http://pinoytech.org/question/4913555/find-twitter-hashtags-using-jquery-and-apply-a-link
  var hashtag_regexp = /#([a-zA-Z0-9]+)/g;
  var name = task.name;
  var tags = task.tags;

  function linkHashtags(text) {
    return text.replace(
      hashtag_regexp,
      '<a class="hashtag" href="http://twitter.com/#search?q=$1">#$1</a>'
    );
  }
}

function today(plus) {
  plus = plus || 0;
  var date = new Date();
  date.setDate(date.getDate() + plus);
  var yyyy = date.getFullYear();
  var mm = date.getMonth() + 1;
  var dd = date.getDate();
  mm = mm < 10 ? '' + '0' + mm : '' + mm; // pad left with 0
  dd = dd < 10 ? '' + '0' + dd : '' + dd; // pad left with 0
  return '' + yyyy + mm + dd;
}

function timetoymd(unixtime) {
  var microtime = unixtime * 1000;
  var date = new Date();
  date.setTime(microtime);
  var yyyy = date.getFullYear();
  var mm = date.getMonth() + 1;
  var dd = date.getDate();
  mm = mm < 10 ? '' + '0' + mm : '' + mm; // pad left with 0
  dd = dd < 10 ? '' + '0' + dd : '' + dd; // pad left with 0
  var str = yyyy < 2000 ? '' : '' + yyyy + mm + dd;
  return str;
}

function timetomd(unixtime) {
  var microtime = unixtime * 1000;
  var date = new Date();
  date.setTime(microtime);
  return ymdtomd(datetoymd(date));
}

function timetomdhi(unixtime) {
  if (unixtime == 0) return '';
  
  var microtime = unixtime * 1000;
  var date = new Date(microtime);
  var locale = getLocale();
  
  try {
    var datePart = date.toLocaleDateString(locale, { 
      month: 'short', 
      day: 'numeric' 
    });
    var timePart = date.toLocaleTimeString(locale, { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit',
      hour12: false 
    });
    return datePart + ' - ' + timePart;
  } catch (e) {
    console.error('Date formatting error:', e);
    var datePart = date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    });
    var timePart = date.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit', 
      second: '2-digit',
      hour12: false 
    });
    return datePart + ' - ' + timePart;
  }
}

function timetoDate(unixtime) {
  var microtime = unixtime * 1000;
  var date = new Date();
  date.setTime(microtime);
  return date;
}

function ymdtostr(ymd) {
  if (!ymd || ymd.length !== 8) return '';
  
  // Use the existing ymdtolocale function for consistency
  return ymdtolocale(ymd, 'MMMDY');
}

// Helper function for consistent locale detection
function getLocale() {
  if (
    NIRV.prefs &&
    NIRV.prefs['UIDateLocale'] &&
    NIRV.prefs['UIDateLocale'].value
  ) {
    return NIRV.prefs['UIDateLocale'].value;
  } else if (
    NIRV.prefs &&
    NIRV.prefs['UILanguage'] &&
    NIRV.prefs['UILanguage'].value
  ) {
    // Map UI language to appropriate locale
    switch (NIRV.prefs['UILanguage'].value) {
      case 'es':
        return 'es-ES';
      case 'fr':
        return 'fr-FR';
      case 'ja':
        return 'ja-JP';
      case 'en':
      default:
        return 'en-US';
    }
  } else {
    // Ultimate fallback to browser's language or en-US
    return (typeof navigator !== 'undefined' && navigator.language) || 'en-US';
  }
}

function ymdtolocale(ymd, style, locale) {
  style = style || 'SMART';
  locale = locale || getLocale();

  var yyyy = ymd.slice(0, 4);
  var mm = parseInt(ymd.slice(4, 6)) - 1;
  var dd = ymd.slice(6, 8);
  var date = new Date(yyyy, mm, dd);
  var options = {};

  if (style == 'SMART') {
    var this_year = new Date().toString('yyyy');
    if (yyyy == this_year) {
      style = 'MMMD';
    } else {
      style = 'MMMDY';
    }
  }

  if (style == 'SHORT') {
    var this_year = new Date().toString('yyyy');
    if (yyyy == this_year) {
      style = 'MMMD';
    } else {
      style = 'MMMY';
    }
  }

  switch (style) {
    // case 'MDY': options = { year: 'numeric', month: '2-digit', day: '2-digit' }; break;
    case 'MDY':
      options = { year: 'numeric', month: 'numeric', day: 'numeric' };
      break;
    case 'MMMD':
      options = { month: 'short', day: 'numeric' };
      break;
    case 'MMMY':
      options = { year: 'numeric', month: 'short' };
      break;
    case 'MMMDY':
      options = { year: 'numeric', month: 'short', day: 'numeric' };
      break;
  }

  try {
    return date.toLocaleDateString(locale, options);
  } catch (e) {
    console.error(e);
    return date.toLocaleDateString('en-US', options);
  }
}

function ymdtomd(ymd) {
  if (ymd == undefined) {
    return 'ymd';
  }
  return ymdtolocale(ymd, 'MMMD');
  // var yyyy = ymd.slice(0, 4);
  // var mm = parseInt(ymd.slice(4, 6)) - 1;
  // var dd = ymd.slice(6, 8);
  // var date = new Date(yyyy, mm, dd);
  // var datetoday = new Date();
  // if (date.toString('yyyy') != datetoday.toString('yyyy')) {
  //     return date.toString('M/d/yyyy');
  // } else {
  //     return date.toString('MMM d');
  // }
}

function datetoymd(date) {
  var yyyy = date.getFullYear();
  var mm = date.getMonth() + 1;
  var dd = date.getDate();
  mm = mm < 10 ? '0' + mm : mm;
  dd = dd < 10 ? '0' + dd : dd;
  return '' + yyyy + mm + dd;
}

function duedatetohuman(yyyymmdd) {
  var out = '';
  var timestamp = parseInt(
    new Date(yyyymmdd2mmddyyyy(yyyymmdd)).getTime().toString().slice(0, 10)
  );
  var dueinxdays = Math.floor((time() - timestamp) / 86400);
  if (timestamp > 0) {
    // Check if localization is available
    var hasLocalization =
      NIRV.L &&
      NIRV.L.due_today &&
      NIRV.L.due_tomorrow &&
      NIRV.L.due_in_x_days &&
      NIRV.L.due_on &&
      NIRV.L.x_day_late &&
      NIRV.L.x_days_late;

    if (hasLocalization) {
      // Use localized strings when available
      if (dueinxdays <= -7) {
        out = NIRV.L.due_on.replace('{date}', timetomd(timestamp));
      } else if (dueinxdays <= -2) {
        out = NIRV.L.due_in_x_days.replace('{count}', -1 * dueinxdays);
      } else if (dueinxdays == -1) {
        out = NIRV.L.due_tomorrow;
      } else if (dueinxdays == 0) {
        out = NIRV.L.due_today;
      } else if (dueinxdays == 1) {
        out = NIRV.L.x_day_late;
      } else if (dueinxdays >= 2) {
        out = NIRV.L.x_days_late.replace('{count}', dueinxdays);
      }
    } else {
      // Fallback to English only when localization is not available
      if (dueinxdays <= -7) {
        out = (NIRV.L.due || 'Due') + ' ' + timetomd(timestamp);
      } else if (dueinxdays <= -2) {
        out = (NIRV.L.due_in_x_days || 'Due in {count} Days').replace('{count}', -1 * dueinxdays);
      } else if (dueinxdays == -1) {
        out = NIRV.L.due_tomorrow || 'Due Tomorrow';
      } else if (dueinxdays == 0) {
        out = NIRV.L.due_today || 'Due Today';
      } else if (dueinxdays == 1) {
        out = NIRV.L.x_day_late || '1 Day Late';
      } else if (dueinxdays >= 2) {
        out = (NIRV.L.x_days_late || '{count} Days Late').replace('{count}', dueinxdays);
      }
    }
  }
  return out;
}

function etimetostr(etime) {
  etime = etime.toString();
  var str = '';
  switch (etime) {
    case '0':
      str = NIRV.L && NIRV.L.none ? NIRV.L.none : 'none';
      break;
    case '5':
      str = NIRV.L && NIRV.L.minutes_5 ? NIRV.L.minutes_5 : '5 minutes';
      break;
    case '10':
      str = NIRV.L && NIRV.L.minutes_10 ? NIRV.L.minutes_10 : '10 minutes';
      break;
    case '15':
      str = NIRV.L && NIRV.L.minutes_15 ? NIRV.L.minutes_15 : '15 minutes';
      break;
    case '20':
      str = '20 minutes'; // No token exists for 20 minutes
      break;
    case '30':
      str = NIRV.L && NIRV.L.minutes_30 ? NIRV.L.minutes_30 : '30 minutes';
      break;
    case '45':
      str = NIRV.L && NIRV.L.minutes_45 ? NIRV.L.minutes_45 : '45 minutes';
      break;
    case '60':
      str = NIRV.L && NIRV.L.hour_1 ? NIRV.L.hour_1 : '1 hour';
      break;
    case '120':
      str = NIRV.L && NIRV.L.hours_2 ? NIRV.L.hours_2 : '2 hours';
      break;
    case '180':
      str = NIRV.L && NIRV.L.hours_3 ? NIRV.L.hours_3 : '3 hours';
      break;
    case '240':
      str = NIRV.L && NIRV.L.hours_4 ? NIRV.L.hours_4 : '4 hours';
      break;
    case '360':
      str = NIRV.L && NIRV.L.hours_6 ? NIRV.L.hours_6 : '6 hours';
      break;
    case '480':
      str = NIRV.L && NIRV.L.hours_8 ? NIRV.L.hours_8 : '8 hours';
      break;
    case '600':
      str = NIRV.L && NIRV.L.whoa_nelly ? NIRV.L.whoa_nelly : 'whoa nelly!';
      break;
  }
  return str;
}

function etimehumansum(etime) {
  etime = parseInt(etime);
  var out = '';
  var m = '';
  var h = '';
  if (etime < 60) {
    out = etime + 'm';
  } else {
    h = Math.floor(etime / 60);
    m = etime % 60;
    if (h == 1) {
      out = '1h ';
    } else if (h > 1) {
      out = h + 'h ';
    }
    if (m != 0) {
      out += m + 'm';
    }
  }
  return out;
}

function energytomstr(energy) {
  energy = energy.toString();
  var str = '';
  switch (energy) {
    case '1':
      str = '•';
      break;
    case '2':
      str = '••';
      break;
    case '3':
      str = '•••';
      break;
  }
  return str;
}

function energytostr(energy) {
  energy = energy.toString();
  var str = '';
  switch (energy) {
    case '0':
      str = NIRV.L && NIRV.L.none ? NIRV.L.none : 'none';
      break;
    case '1':
      str = NIRV.L && NIRV.L.low_energy ? NIRV.L.low_energy : 'low energy •';
      break;
    case '2':
      str = NIRV.L && NIRV.L.medium_energy ? NIRV.L.medium_energy : 'medium energy ••';
      break;
    case '3':
      str = NIRV.L && NIRV.L.high_energy ? NIRV.L.high_energy : 'high energy •••';
      break;
  }
  return str;
}

function statetostr(state) {
  state = state.toString();
  var str = '';
  switch (state) {
    case '0':
      str = NIRV.L && NIRV.L.inbox ? NIRV.L.inbox : 'Inbox';
      break;
    case '1':
      str = NIRV.L && NIRV.L.next ? NIRV.L.next : 'Next';
      break;
    case '2':
      str = NIRV.L && NIRV.L.waiting ? NIRV.L.waiting : 'Waiting';
      break;
    case '3':
      str = NIRV.L && NIRV.L.scheduled ? NIRV.L.scheduled : 'Scheduled';
      break;
    case '4':
      str = NIRV.L && NIRV.L.someday ? NIRV.L.someday : 'Someday';
      break;
    case '5':
      str = NIRV.L && NIRV.L.later ? NIRV.L.later : 'Later';
      break;
    case '6':
      str = NIRV.L && NIRV.L.trash ? NIRV.L.trash : 'Trash';
      break;
    case '7':
      str = NIRV.L && NIRV.L.logbook ? NIRV.L.logbook : 'Logbook';
      break;
    case '8':
      str = 'Deleted'; // No token exists for deleted
      break;
    case '9':
      str = NIRV.L && NIRV.L.recurring ? NIRV.L.recurring : 'Recurring';
      break;
    case '10':
      str = NIRV.L && NIRV.L.reference ? NIRV.L.reference : 'Reference';
      break;
    case '11':
      str = NIRV.L && NIRV.L.active ? NIRV.L.active : 'Active';
      break;
  }
  return str;
}

function recurringtostr(recurring, markup) {
  var recurring = JSON.parse(recurring);
  var htmlmarkup = markup == 'text' ? false : true;
  var out = NIRV.L.repeats_every || 'Repeats Every '; // No token exists for "repeats every"
  // interval
  if (recurring.interval > 1) {
    out += recurring.interval + ' ';
  }
  // frequency
  if (recurring.freq == 'daily') {
    out += NIRV.L && NIRV.L.day ? NIRV.L.day : 'Day';
  }
  if (recurring.freq == 'weekly') {
    out += 'Week'; // No singular "week" token exists (only "rr_weekly")
  }
  if (recurring.freq == 'monthly') {
    out += 'Month'; // No singular "month" token exists (only "rr_monthly")
  }
  if (recurring.freq == 'yearly') {
    out += 'Year'; // No singular "year" token exists (only "rr_yearly")
  }
  // pluralize
  if (recurring.interval > 1) {
    out += 's ';
  } else {
    out += ' ';
  }
  // on
  var nextdates = NIRV.calcnextdates(recurring);
  if (htmlmarkup) {
    out += '<span class="nextdates cmenu_state">';
  } else {
    out += ' \n';
  }
  if (recurring.hasduedate == 1) {
    out += NIRV.L && NIRV.L.due_on ? NIRV.L.due_on + ' ' : 'Due on ';
  } else {
    out += NIRV.L && NIRV.L.next_up ? NIRV.L.next_up + ' ' : 'Next up ';
  }
  for (var i = 0; i < nextdates.length; i++) {
    if (i < 2) {
      // out += new Date(yyyymmdd2mmddyyyy(nextdates[i])).toString('M/d/yy');
      out += ymdtolocale(nextdates[i], 'MDY');
    }
    if (i < 1) {
      out += ', ';
    }
    if (i == 2) {
      out += ' …';
    }
  }
  if (htmlmarkup) {
    out += '</span>';
  }
  return out;
}

function sortEntitiesBy(entities, column, ascdesc, numeric) {
  // insanity
  ascdesc = ascdesc || 'asc';
  numeric = numeric || false;

  // sanitize
  ascdesc = ascdesc == 'desc' ? 'desc' : 'asc';
  numeric = numeric == true ? true : false;

  // vars
  var entity = {};
  var oentities = {}; // entities --> converted to object / collection with entityid as key
  var rentities = []; // entities --> sorted, to be returned by this method / function, incremented 0-n
  var column_entityids = []; // to hold concat: column | entityid, for array sort by string comparison
  var i; // iter
  var entityid = 0; // temp entity holder
  var exploded = [];

  // ensure we are dealing with an object
  for (i = 0; i < entities.length; i++) {
    if (typeof entities != 'function') {
      oentities[entities[i].id] = entities[i];
    }
  }

  // pad column value as array key for string based sorting
  if (numeric) {
    for (i in oentities) {
      column_entityids.push(
        padleft(oentities[i][column].toString(), 10) + '\r' + oentities[i].id
      );
    }
  } else {
    for (i in oentities) {
      column_entityids.push(
        oentities[i][column].toLowerCase() + '\r' + oentities[i].id
      );
    }
  }

  // sort asc/desc
  if (ascdesc == 'asc') {
    column_entityids.sort();
  } else {
    column_entityids.sort();
    column_entityids.reverse();
  }

  // build return object
  for (i = 0; i < column_entityids.length; i++) {
    exploded = column_entityids[i].split('\r');
    var id = exploded[1];
    if (oentities[id] != undefined) {
      rentities[i] = oentities[id];
    }
  }

  return rentities;
}

function _isvalid_yyyymmdd(date) {
  date = date || '';
  date = date.toString();
  if (parseInt(date, 10) != date) {
    return false;
  }
  if (date.length != 8) {
    return false;
  }
  if (date < 20000101 || date > 20991231) {
    return false;
  }
  return true;
}

// RECURRING ADDITIONS

function datetommddyy(date) {
  var mm = '' + (date.getMonth() + 1);
  var dd = '' + date.getDate();
  var yy = '' + (date.getFullYear() + '').substr(2, 2);
  return mm + '/' + dd + '/' + yy;
}

function datetommddyyyy(date) {
  var mm = '' + (date.getMonth() + 1);
  var dd = '' + date.getDate();
  var yyyy = '' + date.getFullYear();
  return mm + '/' + dd + '/' + yyyy;
}

function mmddyyyy2yyyymmdd(s) {
  var parts = s.split('/');
  var mm = '' + parts[0];
  var dd = '' + parts[1];
  var yyyy = '' + parts[2];
  return '' + yyyy + mm + dd;
}

function yyyymmdd2mmddyyyy(s) {
  var yyyy = s.substr(0, 4);
  var mm = s.substr(4, 2);
  var dd = s.substr(6, 2);
  return mm + '/' + dd + '/' + yyyy;
}

function yyyymmdd2time(s) {
  var yyyy = parseInt(s.substr(0, 4));
  var mm = parseInt(s.substr(4, 2)) - 1; // js months are from 0 - 11
  var dd = parseInt(s.substr(6, 2));
  var newdate = new Date(yyyy, mm, dd);
  return newdate.getTime() / 1000 || 0;
}

// CREDIT: http://stackoverflow.com/questions/1248302/javascript-object-size
function roughSizeOfObject(object) {
  var objectList = [];
  var recurse = function (value) {
    var bytes = 0;
    if (typeof value === 'boolean') {
      bytes = 4;
    } else if (typeof value === 'string') {
      bytes = value.length * 2;
    } else if (typeof value === 'number') {
      bytes = 8;
    } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
      objectList[objectList.length] = value;

      for (i in value) {
        bytes += 8; // an assumed existence overhead
        bytes += recurse(value[i]);
      }
    }
    return bytes;
  };

  return recurse(object);
}

var bytesToHuman = function (bytes) {
  if (bytes > 1000 * 1000) {
    return Math.round((bytes / 1000 / 1000) * 10) / 10 + 'M'; // megabytes
  } else {
    return Math.round(bytes / 1000) + 'K'; // kilobytes
  }
};

// courtesy chatGPT
const toInt = (value) => parseInt(value, 10) || 0;

function deepCleanseAndSort(obj, validKeys, typeMap) {
  validKeys = validKeys || [
    'id',
    // 'name',
    // 'note',
    // 'tags',
    // 'seq',
    // 'seqt',
    // 'seqp',
    // 'state',
    // 'startdate',
    // 'duedate',
    // 'completed',
    // 'deleted',
    // 'type',
    // 'ps',
    // '_name',
    // '_note',
    // '_tags',
    // '_seq',
    '_seqt',
    // '_seqp',
    // '_state',
    // '_startdate',
    // '_duedate',
    // '_completed',
    // '_deleted',
    // '_type',
    // '_ps',
  ];
  typeMap = typeMap || {
    id: 'string',
    name: 'string',
    note: 'string',
    tags: 'string',
    seq: 'int',
    seqt: 'int',
    seqp: 'int',
    state: 'int',
    startdate: 'string',
    duedate: 'string',
    completed: 'int',
    deleted: 'int',
    type: 'int',
    ps: 'int',
    _name: 'int',
    _note: 'int',
    _tags: 'int',
    _seq: 'int',
    _seqt: 'int',
    _seqp: 'int',
    _state: 'int',
    _startdate: 'int',
    _duedate: 'int',
    _completed: 'int',
    _deleted: 'int',
    _type: 'int',
    _ps: 'int',
  };
  if (Array.isArray(obj)) {
    return obj.map((item) => deepCleanseAndSort(item, validKeys, typeMap)); // Recursively process arrays
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj)
      .filter((key) => validKeys.includes(key)) // Remove unrecognized keys
      .sort() // Sort keys alphabetically
      .reduce((sorted, key) => {
        let value = deepCleanseAndSort(obj[key], validKeys, typeMap); // Recursively process values

        // Type casting based on type map
        if (typeMap[key] === 'int') value = parseInt(value, 10) || 0;
        else if (typeMap[key] === 'string') value = String(value);

        sorted[key] = value;
        return sorted;
      }, {});
  } else {
    return obj; // Return primitive values as-is
  }
}

window.atasks = () => {
  let keys = Object.keys(NIRV.tasks).sort();
  let tasks = keys.map((key) => NIRV.tasks[key]);
  let result = deepCleanseAndSort(tasks);
  return result;
};

function formatYMD(ymd, locale = navigator.language) {
  if (!/^\d{8}$/.test(ymd)) {
    throw new Error('Invalid YMD format. Expected YYYYMMDD.');
  }

  const year = parseInt(ymd.slice(0, 4), 10);
  const month = parseInt(ymd.slice(4, 6), 10) - 1;
  const day = parseInt(ymd.slice(6, 8), 10);

  const date = new Date(year, month, day); // local time (simple)

  const formats = {
    numeric: { year: 'numeric', month: 'numeric', day: 'numeric' },
    shortFull: { year: 'numeric', month: 'short', day: 'numeric' },
    shortPartial: { month: 'short', day: 'numeric' },
  };

  return {
    locale,
    date,
    numeric: date.toLocaleDateString(locale, formats.numeric),
    shortFull: date.toLocaleDateString(locale, formats.shortFull),
    shortPartial: date.toLocaleDateString(locale, formats.shortPartial),
  };
}

// Helper function to apply jQuery UI datepicker localization
function applyDatepickerLocalization(forceLanguage) {
  if (!$ || !$.datepicker) return; // Ensure jQuery UI datepicker is available

  // Get current language from i18next (single source of truth) or use forced language
  var language = forceLanguage || 'en'; // use provided language first
  if (
    !forceLanguage &&
    window.NirvanaI18next &&
    typeof window.NirvanaI18next.getCurrentLanguage === 'function'
  ) {
    language = window.NirvanaI18next.getCurrentLanguage();
  }

  console.log('🗓️ Applying datepicker localization for language:', language);

  var locale =
    (NIRV.prefs && NIRV.prefs.UIDateLocale && NIRV.prefs.UIDateLocale.value) ||
    'en-US';

  // Define localized strings for datepicker
  var localization = {};

  switch (language) {
    case 'es':
      localization = {
        monthNames: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre',
        ],
        monthNamesShort: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic',
        ],
        dayNames: [
          'Domingo',
          'Lunes',
          'Martes',
          'Miércoles',
          'Jueves',
          'Viernes',
          'Sábado',
        ],
        dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
        prevText: 'Anterior',
        nextText: 'Siguiente',
        currentText: 'Hoy',
        closeText: 'Cerrar',
      };
      break;

    case 'fr':
      localization = {
        monthNames: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ],
        monthNamesShort: [
          'Jan',
          'Fév',
          'Mar',
          'Avr',
          'Mai',
          'Jun',
          'Jul',
          'Aoû',
          'Sep',
          'Oct',
          'Nov',
          'Déc',
        ],
        dayNames: [
          'Dimanche',
          'Lundi',
          'Mardi',
          'Mercredi',
          'Jeudi',
          'Vendredi',
          'Samedi',
        ],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
        prevText: 'Précédent',
        nextText: 'Suivant',
        currentText: "Aujourd'hui",
        closeText: 'Fermer',
      };
      break;

    case 'ja':
      localization = {
        monthNames: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        monthNamesShort: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ],
        dayNames: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日',
        ],
        dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
        dayNamesMin: ['日', '月', '火', '水', '木', '金', '土'],
        prevText: '前月',
        nextText: '翌月',
        currentText: '今日',
        closeText: '閉じる',
      };
      break;

    default: // English
      localization = {
        monthNames: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        monthNamesShort: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ],
        dayNames: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        prevText: 'Previous',
        nextText: 'Next',
        currentText: 'Today',
        closeText: 'Close',
      };
      break;
  }

  // Apply the localization to jQuery UI datepicker defaults
  $.datepicker.setDefaults(localization);

  // Refresh any existing datepicker instances to apply new localization
  $('.hasDatepicker').each(function () {
    var $this = $(this);
    if ($this.data('datepicker')) {
      try {
        // Get current options and value
        var currentValue = $this.val();
        // Refresh the datepicker with new localization
        $this.datepicker('refresh');
        // Restore the value if it was set
        if (currentValue) {
          $this.val(currentValue);
        }
      } catch (e) {
        // Silently handle any errors during refresh
        console.warn('Could not refresh datepicker instance:', e);
      }
    }
  });
}
